import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Storage } from "@ionic/storage";

@IonicPage()
@Component({
  selector: "page-shopper-buy-social-pay",
  templateUrl: "shopper-buy-social-pay.html",
})
export class ShopperBuySocialPayPage {
  plaza = "";
  data = { plaza_id: "", shop_id: "", shop_name: "", avalible: "", price: "" };
  bgImage = "";
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage
  ) {
    this.data = this.navParams.data;
    this.bgImage = "assets/bg/social/" + this.data.shop_id + ".jpg";
    // this.bgImage = 'assets/bg/social/1.jpg';

    if (this.data.plaza_id == "1") {
      this.plaza = "A";
    } else if (this.data.plaza_id == "2") {
      this.plaza = "B";
    } else if (this.data.plaza_id == "3") {
      this.plaza = "C";
    } else if (this.data.plaza_id == "4") {
      this.plaza = "D";
    } else if (this.data.plaza_id == "5") {
      this.plaza = "E";
    } else if (this.data.plaza_id == "6") {
      this.plaza = "F";
    } else {
      this.plaza = this.data.plaza_id;
    }
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
  }

  scan() {
    // this.navCtrl.push(ShopperBuyProductPayScanPage, {space: this.data});
  }

  backPage() {
    this.navCtrl.pop();
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-social-pay/shopper-buy-social-pay.ts